import { useContext } from "react";
import { useLocation } from "react-router-dom";
import { urls } from "../../urls";
import { useSub } from "../subscription/useSub";
import { AssistantPanelContext } from "./assistantPanelContext";

export const useAssistantEntry = ({ onPage = false }: { onPage?: boolean } = {}): (() => void) | null => {
  const { canUseAssistant } = useSub();
  const panel = useContext(AssistantPanelContext);
  const { pathname } = useLocation();
  if (!panel || !canUseAssistant || pathname === urls.app.assistant) return null;
  return onPage ? (panel.openOnPage ?? panel.openPanel) : panel.openPanel;
};
